module.exports = __webpack_public_path__ + "img/icon-illustration-coupon.f5dfdd71.svg";